import React from 'react';

const TableHead = () => (
    <thead className="thead-light">
        <tr>
        <th scope="col">Nome</th>
        <th scope="col">Descrição</th>
        <th scope="col">Valor</th>
        </tr>
    </thead>
);

export default TableHead;


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Items/TableHead.js